import React from 'react';
import { View } from 'react-native';
import IdeaCard from '@/components/Ideas/IdeaCard';
import { discoverySampleKind } from './DiscoverySample';
import { discoveryPreviewKind } from './DiscoveryPreview';

// A small number of distinct visual highlights, followed by concise suggestions.
// Grouping keeps pagination stable and prevents empty cells at section boundaries.
export default function IdeaGroup({ items, groupIndex = 0, width, palette, onSelect, onSeen, samples = true }) {
  const wide = width >= 620;
  const seen = new Set();
  const ordered = [...items].sort((a, b) => Number(Boolean(discoverySampleKind(b))) - Number(Boolean(discoverySampleKind(a))));
  const highlights = ordered.filter(item => {
    const kind = discoveryPreviewKind(item);
    if (seen.has(kind) || seen.size >= (groupIndex % 2 ? 1 : 2)) return false;
    seen.add(kind);
    return true;
  });
  const rest = items.filter(item => !highlights.includes(item));
  const half = wide ? (width - 16) / 2 : '100%';
  return <View style={{ width: '100%', gap: 16 }}>
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 16 }}>
      {highlights.map(idea => <IdeaCard key={idea.id || idea.title} idea={idea} palette={palette}
        width={highlights.length === 1 ? '100%' : half} featured={wide && highlights.length === 1}
        onPress={onSelect} onSeen={onSeen} samples={samples} />)}
    </View>
    {!!rest.length && <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 16 }}>
      {rest.map(idea => <IdeaCard key={idea.id || idea.title} idea={idea} palette={palette}
        width={half} compact onPress={onSelect} onSeen={onSeen} samples={samples} />)}
    </View>}
  </View>;
}
